import type {FormikConnected} from '@interfaces/FormikConnected';
import type ValueList from '@interfaces/ValueList';
import type {FormikContextType} from 'formik';
import {connect} from 'formik';
import type {ReactElement} from 'react';

interface Props {
    customErrorMessage?: string;
    className?: string;
}

function getErrorMessage({touched, errors, status}: FormikContextType<ValueList<string>>): string {
    if (status) {
        return status as string;
    }

    return Object.keys(touched).reduce((acc: string, item: keyof ValueList) => {
        if (!acc && touched[item] && errors[item]) {
            return errors[item];
        }

        return acc;
    }, '');
}

function ErrorMessage({
    formik,
    customErrorMessage,
    className,
}: FormikConnected<ValueList<string>> & Props): ReactElement<Props> {
    return <div className={className}>{customErrorMessage ?? getErrorMessage(formik)}</div>;
}

export default connect<Props>(ErrorMessage);
